var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import { classNames } from '../utils';
function Checkbox(_a) {
    var { className, customIcon } = _a, props = __rest(_a, ["className", "customIcon"]);
    return (_jsx(CheckboxPrimitive.Root, Object.assign({ "data-slot": "checkbox", className: classNames('peer focus:ring-primary data-[state=checked]:border-brand-500 data-[state=checked]:bg-brand-500 border-base-300 hover:border-base-400 h-4 w-4 shrink-0 rounded-sm border-1 bg-white shadow-sm transition-all duration-200 focus:ring-0 focus:ring-offset-0 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-white', className) }, props, { children: _jsx(CheckboxPrimitive.Indicator, { "data-slot": "checkbox-indicator", className: "flex items-center justify-center text-current", children: customIcon ? (customIcon) : (_jsx(CheckIcon, { className: "h-3 w-3 font-medium", strokeWidth: 2.5 })) }) })));
}
export default Checkbox;
